import { MdePopoverModule } from '@ajustee/mde-popover';
import { CurrencyPipe, DatePipe, registerLocaleData } from '@angular/common';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import ptBr from '@angular/common/locales/pt';
import { LOCALE_ID, NgModule } from '@angular/core';
import { GoogleMapsModule } from '@angular/google-maps';
import { MatMomentDateModule } from '@angular/material-moment-adapter';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatBadgeModule } from '@angular/material/badge';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatPaginatorIntl, MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { FuseProgressBarModule, FuseSidebarModule, FuseThemeOptionsModule } from '@fuse/components';
import { FuseModule } from '@fuse/fuse.module';
import { FuseSharedModule } from '@fuse/shared.module';
import { TranslateModule } from '@ngx-translate/core';
import { InMemoryWebApiModule } from 'angular-in-memory-web-api';
import { AppComponent } from 'app/app.component';
import { FakeDbService } from 'app/fake-db/fake-db.service';
import { fuseConfig } from 'app/fuse-config';
import { LayoutModule } from 'app/layout/layout.module';
import { AppStoreModule } from 'app/store/store.module';
import 'hammerjs';
import { ColorPickerModule } from 'ngx-color-picker';
import { AuthGuard } from './helpers/auth.guard';
import { AuthenticationService } from './helpers/authentication.service';
import { NoCacheHeadersInterceptor } from './helpers/cache.interceptor';
import { ErrorInterceptor } from './helpers/error.interceptor';
import { ExcelService } from './helpers/ExcelService.service';
import { JwtInterceptor } from './helpers/jwt.interceptor';
import { getPaginatorIntl } from './helpers/paginator-intl-pt';
import { PDFDespesaPorConsultorService } from './main/a2w/gestor/relatorio-despesa-viagem/services/pdf-despesas-consultor.service';
import { PedidoFakeDb } from './main/cadastros/pedido/pedidos/fake-pedidos';
import { AlertaComponent } from './shared/alertas/alerta.component';
import { ExcelExportComponent } from './shared/excel-export/excel-export.component';
import { PedidoAtividadeService } from './shared/pedido-atividade.service';
import { PlanilhaUploadComponent } from './shared/planilha-upload/planilha-upload.component';
import { SnackbarComponent } from './shared/snack-bar-new-design/snack-bar-new-design.component';
import { ZoomImagemComponent } from './shared/zoom-imagem/zoom-imagem.component';


registerLocaleData(ptBr)

export function initializeApp1(authService: AuthenticationService) {
    return () => new Promise(resolve => {
        // attempt to refresh token on app start up to auto authenticate
        authService.refreshToken()
            .subscribe()
            .add(resolve);
    });
  }

const appRoutes: Routes = [
    {
        path        : 'pages',
        loadChildren: () => import('./main/pages/pages.module').then(m => m.PagesModule),
    },
    {   
        path: '',   
        redirectTo: 'pages/auth/login-2',
        pathMatch: 'full' 
    }, 
    {
        path: 'a2w',
        loadChildren: () => import('./main/a2w/a2w.module').then(x=> x.A2WModule),
        canActivate: [AuthGuard]
    },
    {
        // Shell de Micro Frontends: carrega MFEs (Web Components) em runtime.
        // Ex.: /mfe/relatorios. Ver docs/mfe-architecture.md.
        path: 'mfe',
        loadChildren: () => import('./mfe/mfe.module').then(m => m.MfeModule),
        canActivate: [AuthGuard]
    },
    {
        path: 'home',
        redirectTo: 'pages/home',
        pathMatch: 'full',
    },
    {
        path: 'politica-de-privacidade',
        redirectTo: 'pages/politica-de-privacidade',
        pathMatch: 'full',
    },
    {
        path: 'termos-de-uso',
        redirectTo: 'pages/termos-de-uso',
        pathMatch: 'full',
    },
    {
        path      : '&&',
        redirectTo: '/a2w/inicio',        
        
    },
    {
        path      :'**',
        redirectTo: 'pages/errors/error-404'
    }
];

@NgModule({
    declarations: [
        AppComponent, ZoomImagemComponent, AlertaComponent, PlanilhaUploadComponent, ExcelExportComponent, SnackbarComponent
    ],
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        HttpClientModule,
        RouterModule.forRoot(appRoutes, { preloadingStrategy: PreloadAllModules }),
 
        TranslateModule.forRoot(),
        InMemoryWebApiModule.forRoot(FakeDbService, {
            delay             : 0,
            passThruUnknownUrl: true
        }),

        // Material moment date module
        MatMomentDateModule,

        // Material
        MatButtonModule,
        MatIconModule,
        MatSnackBarModule,
        MatTooltipModule,
        MatSnackBarModule,
        MatSortModule,
        MatTabsModule,
        MatPaginatorModule,
        MatTableModule,
        MatButtonModule,
        MatDatepickerModule,
        MatDialogModule,
        MatSelectModule,
        MatCheckboxModule,
        MatFormFieldModule,
        MatChipsModule,
        MatIconModule,
        MatInputModule,
        MatSlideToggleModule,
        MatToolbarModule,
        MatTooltipModule,
        ColorPickerModule,
        MatAutocompleteModule,
        MatFormFieldModule,
        MatButtonModule,
        MatProgressSpinnerModule,
        MatProgressBarModule,
        MatRadioModule,
        MatExpansionModule,
        MatCardModule,
        MatSidenavModule,
        MatBadgeModule,

        // Fuse modules
        FuseModule.forRoot(fuseConfig),
        FuseProgressBarModule,
        FuseSharedModule,
        FuseSidebarModule,
        MatToolbarModule,
        FuseThemeOptionsModule,

        // App modules
        LayoutModule,
        AppStoreModule,
        GoogleMapsModule,
        MdePopoverModule,
        //AddLeadModule
    ],
    providers: [
        PedidoAtividadeService,
        AuthGuard,
        AuthenticationService,
        PedidoFakeDb,
        CurrencyPipe,
        PDFDespesaPorConsultorService,
        DatePipe,
        ExcelService,
        { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
        {provide: LOCALE_ID, useValue: 'pt-BR'},
        {provide: HTTP_INTERCEPTORS, useClass: NoCacheHeadersInterceptor, multi: true },
         { provide: MatPaginatorIntl, useValue: getPaginatorIntl() }
        //{ provide: APP_INITIALIZER,useFactory: initializeApp1, deps: [AuthenticationService], multi: true}
    ],
    bootstrap: [AppComponent]
})
export class AppModule
{
}
